module.exports = __webpack_public_path__ + "img/arrow.4b893f3e.png";